// extracted by mini-css-extract-plugin
export default {"walletButton":"WalletButton_walletButton__-85oy","loading":"WalletButton_loading__HsxJm"};